// extracted by mini-css-extract-plugin
export default {"wrapper":"Sepa_wrapper__WrKzK","description":"Sepa_description__nHHPw","input":"Sepa_input__jHLo0"};